document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.product-faqs');

  sections.forEach(function (section) {
    initProductFAQ(section);
  });


  function initProductFAQ(section) {
    const searchInput = section.querySelector('.product-faqs__search');
    const clearButton = section.querySelector('.product-faqs__search-clear');
    const resultsContainer = section.querySelector('.product-faqs__results');
    const defaultFAQContainer = section.querySelector('.product-faqs__default');
    const faqContent = section.querySelector('.product-faqs__content');

    if (
      !searchInput ||
      !clearButton ||
      !resultsContainer ||
      !defaultFAQContainer ||
      !faqContent
    ) {
      return;
    }

    let searchTimeout;


    /*
     * --------------------------------------------
     * SEARCH INPUT
     * --------------------------------------------
     */

    searchInput.addEventListener('input', function () {
      const searchTerm = searchInput.value.trim();

      clearButton.hidden = searchTerm === '';

      clearTimeout(searchTimeout);


      /*
       * Search cleared
       *
       * Show default 10 FAQs again.
       */

      if (searchTerm.length === 0) {
        resultsContainer.innerHTML = '';
        resultsContainer.hidden = true;

        faqContent.innerHTML = '';
        faqContent.hidden = true;

        defaultFAQContainer.hidden = false;

        return;
      }


      /*
       * Don't search for less than 2 characters.
       */

      if (searchTerm.length < 2) {
        resultsContainer.innerHTML = '';
        resultsContainer.hidden = true;

        return;
      }


      /*
       * Wait 300ms before making request.
       */

      searchTimeout = setTimeout(function () {
        searchProducts(searchTerm);
      }, 300);
    });


    /*
     * --------------------------------------------
     * CLEAR BUTTON
     * --------------------------------------------
     */

    clearButton.addEventListener('click', function () {
      searchInput.value = '';

      clearButton.hidden = true;

      resultsContainer.innerHTML = '';
      resultsContainer.hidden = true;

      faqContent.innerHTML = '';
      faqContent.hidden = true;

      defaultFAQContainer.hidden = false;

      searchInput.focus();
    });


    /*
     * --------------------------------------------
     * SEARCH PRODUCTS
     * --------------------------------------------
     */

    async function searchProducts(searchTerm) {
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=10`
        );

        if (!response.ok) {
          throw new Error('Product search failed');
        }

        const data = await response.json();

        const products =
          data.resources.results.products || [];

        displayResults(products);

      } catch (error) {
        console.error(
          'Product search error:',
          error
        );

        resultsContainer.innerHTML = '';
        resultsContainer.hidden = true;
      }
    }


    /*
     * --------------------------------------------
     * DISPLAY SEARCH RESULTS
     * --------------------------------------------
     */

    function displayResults(products) {
      if (!products.length) {
        resultsContainer.innerHTML = `
          <div class="product-faqs__no-results">
            No products found.
          </div>
        `;

        resultsContainer.hidden = false;

        return;
      }


      resultsContainer.innerHTML = products
        .map(function (product) {
          return `
            <button
              type="button"
              class="product-faqs__result"
              data-product-handle="${escapeHTML(product.handle)}"
              data-product-title="${escapeHTML(product.title)}"
            >

              ${
                product.image
                  ? `
                    <img
                      src="${escapeHTML(product.image)}"
                      alt="${escapeHTML(product.title)}"
                      class="product-faqs__result-image"
                      loading="lazy"
                    >
                  `
                  : ''
              }

              <span class="product-faqs__result-title">
                ${escapeHTML(product.title)}
              </span>

            </button>
          `;
        })
        .join('');

      resultsContainer.hidden = false;
    }


    /*
     * --------------------------------------------
     * SELECT PRODUCT
     * --------------------------------------------
     */

    resultsContainer.addEventListener('click', function (event) {
      const productButton =
        event.target.closest('.product-faqs__result');

      if (!productButton) {
        return;
      }

      const productHandle =
        productButton.dataset.productHandle;

      const productTitle =
        productButton.dataset.productTitle;


      /*
       * Put selected product name in search field.
       */

      searchInput.value = productTitle;

      clearButton.hidden = false;


      /*
       * Hide search dropdown.
       */

      resultsContainer.innerHTML = '';
      resultsContainer.hidden = true;


      /*
       * IMPORTANT:
       *
       * Hide the default 10 FAQ products.
       */

      defaultFAQContainer.hidden = true;


      /*
       * Show selected product container.
       */

      faqContent.hidden = false;


      /*
       * Load selected product FAQ.
       */

      loadProductFAQ(productHandle);
    });


    /*
     * --------------------------------------------
     * LOAD SELECTED PRODUCT FAQ
     * --------------------------------------------
     */

    async function loadProductFAQ(productHandle) {
      try {
        faqContent.innerHTML = `
          <p class="product-faqs__loading">
            Loading FAQs...
          </p>
        `;

        const response = await fetch(
          `/products/${encodeURIComponent(productHandle)}?section_id=product-faqs-data`
        );

        if (!response.ok) {
          throw new Error(
            'FAQ data could not be loaded'
          );
        }

        const faqHTML = await response.text();

        faqContent.innerHTML = faqHTML;

      } catch (error) {
        console.error(
          'Product FAQ error:',
          error
        );

        faqContent.innerHTML = `
          <div class="product-faqs-data__empty">
            <p>
              Unable to load product FAQs.
            </p>
          </div>
        `;
      }
    }


    /*
     * --------------------------------------------
     * ESCAPE HTML
     * --------------------------------------------
     */

    function escapeHTML(value) {
      const div = document.createElement('div');

      div.textContent = value || '';

      return div.innerHTML;
    }


    /*
     * --------------------------------------------
     * CLOSE SEARCH DROPDOWN
     * --------------------------------------------
     */

    document.addEventListener('click', function (event) {
      if (
        !event.target.closest(
          '.product-faqs__search-wrapper'
        )
      ) {
        resultsContainer.hidden = true;
      }
    });
  }
});


